import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openModal,
  closeModal,
} from "../../../store/slices/editModalPackageSlice";
import { FaPencilAlt } from "react-icons/fa";
import { FaRegCircleXmark } from "react-icons/fa6";
import Select from "react-select";
import {
  fetchDataExams,
  updateDataExams,
} from "../../../store/slices/apiExamsSlice";
import { fetchDataCategories } from "../../../store/slices/apiCategorySlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchDataPackage,
  updateDataPackage,
} from "../../../store/slices/apiPackageSlice";

const EditModalPackage = ({
  id,
  title,
  submitButtonText,
  namePackage,
  packageCategory,
  priceValue,
  adminValue,
  schoolValue,
}) => {
  const dispatch = useDispatch();
  const dataExams = useSelector((state) => state.apiPackage.data);
  const categoryOptions = useSelector((state) => state.apiCategory.data);
  const isOpen = useSelector((state) => state.editModalPackage[id] === true);

  const [changePackage, setChangePackage] = useState("");
  const [changePackageCategory, setChangePackageCategory] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [showId, setShowId] = useState("");
  const [changePrice, setChangePrice] = useState("");
  const [changePriceAdmin, setChangePriceAdmin] = useState("");
  const [changePriceSchool, setChangePriceSchool] = useState("");

  useEffect(() => {
    dispatch(fetchDataPackage());
    dispatch(fetchDataCategories());
  }, []);

  const handleOpenModal = () => {
    const itemToEdit = dataExams.data.find((item) => item.id === id);

    if (itemToEdit) {
      setChangePackage(itemToEdit.name);
      setChangePackageCategory(itemToEdit.category_id);
      setShowId(itemToEdit.categoryName);
      setChangePrice(itemToEdit.price);
      setChangePriceAdmin(itemToEdit.adminPrice);
      setChangePriceSchool(itemToEdit.schoolPrice);
    }
    dispatch(openModal(id));
  };

  const handleCloseModal = () => {
    dispatch(closeModal(id));
  };

  const handleOptionChange = (selectedOptions) => {
    setSelectedOption(selectedOptions);
  };

  const handleEditItem = () => {
    const selectedCategoryId = selectedOption ? selectedOption.value : null;

    const updatedData = {
      name: changePackage,
      category_id: selectedCategoryId,
      price: changePrice,
      adminPrice: changePriceAdmin,
      schoolPrice: changePriceSchool,
    };

    dispatch(updateDataPackage({ id: id, updatedData }));
    toast.success("Te dhenat jan ruajtur me sukses!");
    dispatch(fetchDataExams());
    handleCloseModal();
  };
  return (
    <div>
      <button
        data-modal-target="popup-modal"
        data-modal-toggle="popup-modal"
        onClick={handleOpenModal}
      >
        <FaPencilAlt style={{ width: 20, height: 20 }} />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>
          <div
            className="relative bg-white rounded-lg shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto"
            style={{ minWidth: "280px" }}
          >
            <button
              type="button"
              onClick={handleCloseModal}
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
            >
              <FaRegCircleXmark style={{ width: 20, height: 20 }} />
            </button>

            <div className="p-6 text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                {title}
              </h3>
              <form className="space-y-6 text-start" onSubmit={handleEditItem}>
                <div>
                  <label
                    htmlFor="input1"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    {namePackage}:
                  </label>
                  <input
                    type="text"
                    name="input1"
                    id="input1"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder=""
                    value={changePackage}
                    onChange={(e) => setChangePackage(e.target.value)}
                    required
                  />
                </div>

                {packageCategory && (
                  <div>
                    <label
                      htmlFor="input2"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {packageCategory}:
                      <div className="text-gray-400 font-normal mt-1">
                        Kategoria e zgjedhur aktuale: <br />
                        <span className="text-red-400 font-light">
                          {showId}
                        </span>
                      </div>
                    </label>
                    <Select
                      isClearable
                      name="input2"
                      id="input2"
                      value={selectedOption}
                      onChange={handleOptionChange}
                      options={categoryOptions.map((option) => ({
                        value: option.id,
                        label: option.name,
                      }))}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    />
                  </div>
                )}

                {priceValue && (
                  <div>
                    <label
                      htmlFor="input2"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {priceValue}:
                    </label>
                    <input
                      type="text"
                      name="input1"
                      id="input1"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      placeholder=""
                      value={changePrice}
                      onChange={(e) => setChangePrice(e.target.value)}
                      required
                    />
                  </div>
                )}

                {schoolValue && (
                  <div>
                    <label
                      htmlFor="input2"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {schoolValue}:
                    </label>
                    <input
                      type="text"
                      name="input1"
                      id="input1"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      placeholder=""
                      value={changePriceSchool}
                      onChange={(e) => setChangePriceSchool(e.target.value)}
                      required
                    />
                  </div>
                )}

                {adminValue && (
                  <div>
                    <label
                      htmlFor="input2"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {adminValue}:
                    </label>
                    <input
                      type="text"
                      name="input1"
                      id="input1"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      placeholder=""
                      value={changePriceAdmin}
                      onChange={(e) => setChangePriceAdmin(e.target.value)}
                      required
                    />
                  </div>
                )}

                <div className="flex justify-center">
                  <div className="flex items-center">
                    <button
                      data-modal-hide="popup-modal"
                      type="submit"
                      className="text-white bg-blue-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 mr-2 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                    >
                      {submitButtonText}
                    </button>

                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      onClick={handleCloseModal}
                      className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                    >
                      Anulo
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditModalPackage;
